// extracted by mini-css-extract-plugin
module.exports = {"tableBlock":"style_tableBlock__fuFD2"};